// TODO: this should be done in the backend not in the frontend
/**
 * Filter treatments that have treatment cases greater than 0
 * @param data
 * @returns {null|*}
 */
export const filterTreatments = (data) => {
  let result = null
  if (data instanceof Array) {
    result = []
    for (let i = 0; i < data.length; i = i + 1) {
      const filteredData = filterTreatments(data[i])
      if (filteredData) {
        result.push(filterTreatments(data[i]))
      }
    }
  } else {
    if (data instanceof Object) {
      result = {}
      for (const key in data) {
        if (key === 'treatments') {
          if (data[key].cases === 0) {
            return null
          }
          result[key] = filterTreatments(data[key])
        } else {
          if (data[key] instanceof Object || data[key] instanceof Array) {
            result[key] = filterTreatments(data[key])
          } else {
            result[key] = data[key]
          }
        }
      }
    } else {
      result = data
    }
  }
  return result
}
